import { urlState } from './state';
import { cleanUrlParams } from './utils';

const dev = import.meta.env.DEV;

const defaultApiBase = dev ? 'http://localhost:5000' : '/api';
const loadUrlDefault = () => {
  //get default values from url
  const searchParams = new URLSearchParams(window.location.search);
  Object.entries(urlState).map(([key]) => {
    if (searchParams.get(key)) {
      if (key === 'disabled') {
        urlState[key] = Boolean(searchParams.get(key));
      } else if (['lat', 'lon'].includes(key)) {
        urlState[key] = Number(searchParams.get(key));
      } else {
        urlState[key] = searchParams.get(key);
      }

      if (key === 'indicator' && searchParams.get(key)) {
        sessionStorage.setItem('indicator', searchParams.get(key));
      }
    }
  });
  cleanUrlParams();
};
const indicatorChecks = () => {
  loadUrlDefault();
  const indicator =
    urlState.indicator || sessionStorage.getItem('indicator') || import.meta.env.VITE_INDICATOR;
  return indicator || '05_tropical_nights';
};

const defaultIndicator = indicatorChecks();
export const API_BASE = import.meta.env.VITE_API_BASE || defaultApiBase;
export const INDICATOR = defaultIndicator;
